import { Input, Select } from 'antd'
import { t } from 'i18next'
import _ from 'lodash'
import React, { useState } from 'react'

export default function ProceduresFilters ({ procedures, setFilteredProcedures, actors }) {
  const [name, setName] = useState('')
  const [selectedActors, setSelectedActors] = useState([])

  const updateFilteredProcedures = (nameFilter, actorsFilter) => {
    let filteredProcedures = procedures.filter(procedure => procedure.name.includes(nameFilter.toLowerCase()))
    if (actorsFilter.length > 0) {
      filteredProcedures = filteredProcedures.filter(procedure => _.intersection(procedure.actors, actorsFilter).length > 0)
    }
    setFilteredProcedures(filteredProcedures)
  }

  const filterName = (value) => {
    setName(value)
    updateFilteredProcedures(value, selectedActors)
  }

  const filterActors = (values) => {
    setSelectedActors(values)
    updateFilteredProcedures(name, values)
  }

  return (
    <div style={{ display: 'flex', gap: '10px' }}>
      <Input style={{ width: '250px' }} placeholder={t('Admin.Procedure.attributes.name')} onChange={({ target: { value } }) => filterName(value)} />
      <Select style={{ width: '250px' }} placeholder={t('Admin.Procedure.attributes.actors')} onChange={filterActors}
        options={actors} mode="multiple" allowClear />
    </div>
  )
}
